/* eslint-disable max-len */
export const STEPS = {
  LAUNCH_STUDY: 'launch_study',
  SYSTEM_CHECK: 'system_check',
  MICROPHONE_CHECK: 'microphone_check',
  SCREEN_SHARE_INSTRUCTIONS: 'screen_share_instructions',
  SCREEN_SHARE: 'screen_share',
  DO_NOT_CLOSE: 'do_not_close',
};

export const LINKS_HREF = {
  first: 'http://help.playbookux.com/en/articles/6797675-step-1-installing-the-chrome-extension',
  second: 'http://help.playbookux.com/en/articles/6797676-step-2-launching-the-test',
  download_extension: 'https://chrome.google.com/webstore/detail/playbookux-screen-recorde/hkoaocmcjchlpebblflldidnhanndoaf',
  download_instructions: 'https://www.playbookux.com/download-instructions/',
  nda: 'https://www.playbookux.com/nda/',
};

export const RECORDER_STATUS = {
  ABORTED: 'ABORTED',
  COMPLETED: 'COMPLETED',
  IDLE: 'IDLE',
  PAUSED: 'PAUSED',
  RECORDING: 'RECORDING',
  ERROR: 'ERROR',
  LOADING: 'LOADING',
};

export const EXTENSION_ID = 'hkoaocmcjchlpebblflldidnhanndoaf';

export const RECORDER_TYPE = 'chrome extension';

export const MIN_BATTERY_LEVEL = 0.2;
